<template>
    <div :data-overlay="navOverlayBanner">
        <component :is="bannerComponent">
            <template
                v-if="bannerDecoration"
                #bannerDecoration
            >
                <component :is="bannerDecoration" />
            </template>
        </component>
    </div>
</template>

<script setup>
    const { digistormSettings, appId, getGlobalSetField } = storeToRefs(useGlobalStore())
    const { entry } = storeToRefs(useEntryStore())

    const primaryNavSettings = computed(() => {
        return first(getGlobalSetField.value('ds_Navigation_GlobalSet', 'primaryNav'))
    })

    const navOverlayBanner = computed(() => {
        if (get(entry.value, 'hideBanner')) {
            return false
        }

        return !primaryNavSettings.value?.primaryNav_InternalPageShowBackground
    })

    const bannerType = computed(() => {
        return digistormSettings.value.pageBannerType || 'internal-page-banner-default'
    })

    const pageBannerComponents = import.meta.glob('./page/**/banner.async.vue')

    // check for any custom headers
    const customComponents = await import(`~/custom/${appId.value}/index.js`).catch(() => {
        return null
    })

    const bannerDecoration = customComponents?.default?.PageBannerDecoration

    const bannerComponent = computed(() => {
        if (bannerType.value === 'internal-page-banner-custom') {
            return customComponents?.default?.InternalBanner
        }

        return defineAsyncComponent(() => {
            // this can be removed after v0.3 release
            const type = bannerType.value === 'banner-default' ? 'internal-page-banner-default' : bannerType.value
            const banner = pageBannerComponents[`./page/${type}/banner.async.vue`]
            return banner ? banner() : Promise.reject(new Error(`Unknown page banner type: ${type}`))
        })
    })
</script>
